import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo'
import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';
import ContactNumero from '@/generated/controls/contact/ContactNumero.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ContactNumero,
    computed: {
        editFieldInfo(): FieldInfo {
            const type = EditFieldType.STRING;
            const precision = 2;
            const format = null;
            const focus = this.focusValidatorExpend;
            const live = this.liveValidatorExpend;
            const mask = this.maskExpend;
            return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
        }
    },
    methods: {
        focusValidatorExpend(value: string): validator | null {
            if ((value.length >= 1 && value.startsWith('+')) || (value.length >= 2 && value.startsWith('00'))) {
              return new validator(rules.numeroInterValid, RULES_FRENCH_LABEL.text.numeroValid.error);
            } else {
              return new validator(rules.numeroValid, RULES_FRENCH_LABEL.text.numeroValid.error);
            }
        },
        liveValidatorExpend(value: string): validator | null {
            return null;
        },
        maskExpend(value: string): string {
            let res = '';
            if ((value.length >= 1 && value.startsWith('+')) || (value.length >= 2 && value.startsWith('00'))) {
              res = '';
            } else {
              res = 'NN NN NN NN NN';
            }
            return res;
        }
    }
})
